import { daysEs, monthsEs } from "@utils/days";
import dayjs from "@config/dayjs";

const formats = {
  timeGutterFormat: "HH",
  dayFormat: (date: any, locale: "es" | "en" = "es") => {
    return dayjs(date).locale(locale).format("dddd").substr(0, 3);
  },
  dateEsFormat: date => {
    const dayjsDate = dayjs(date);
    const dayIndex = dayjsDate.day() - 1;
    const dateVal = dayjsDate.date();
    const monthIndex = dayjsDate.month();

    return `${daysEs?.[dayIndex]?.toLowerCase()} ${dateVal} de ${monthsEs?.[monthIndex]}`;
  },
};

const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const formatHoursDay = (date: Date) => {
  const format =
    date.getHours().toString().length > 1
      ? date.getHours().toString()
      : "0" + date.getHours().toString();
  return format;
};

const formatMinutesDay = (date: Date) => {
  const format =
    date.getMinutes().toString().length > 1
      ? date.getMinutes().toString()
      : "0" + date.getMinutes().toString();
  return format;
};

export const getDateNumber = (date: number | string) => {
  const dateString = date?.toString();
  return dateString?.length > 1 ? dateString : "0" + dateString;
};

const getFormattedDate = (date: Date | string) => {
  const dayjsDate = dayjs(date);
  const month = dayjsDate.month() + 1;
  const day = dayjsDate.date();
  const year = dayjsDate.year();
  const fullDate = `${year}-${getDateNumber(month)}-${getDateNumber(day)}`;

  return fullDate;
};

export { formats, days, formatHoursDay, formatMinutesDay, getFormattedDate };
